<template>
  <div class="income" ref="refDialog">
    <div class="income-dialog">
      <div class="income-dialog-header" ref="refDialogHeader">
        <span>按住此处可拖动窗口</span>
      </div>
      <div class="income-dialog-body">
        <div class="income-meta">
          <div class="income-meta-city">{{customerIncomingDetails.city || "未知"}}</div>
          <div class="income-meta-city" v-if="initData.convId">转人节点：{{initData.convId}}</div>
          <div class="income-meta-name">
            <span
              class="income-meta-name-box flex-center"
              v-if="![null, 'null', '', 0, undefined, 'undefined'].includes(customerIncomingDetails.name)">{{customerIncomingDetails.name}}</span>
          </div>
          <div class="income-meta-phone">{{customerIncomingDetails.phone || "未知"}}</div>
          <div class="income-meta-phone" style="font-size: 14px;">该号码进线{{initData.callInCount}}次</div>
        </div>
        <div class="income-footer">
          <span class="income-footer-left flex-center" @click="$emit('refuse')">
            <i class="el-icon-close"></i>
          </span>
          <span class="income-footer-right flex-center" @click="$emit('sipLink')">
            <i class="el-icon-phone"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DragModalHeader from '@/components/mixins/DragModalHeader2';

export default {
  mixins: [DragModalHeader],
  props: {
    initData: Object,
  },
  computed: {
    customerIncomingDetails(){
      return this.initData.customerIncomingDetails || {};
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss">

</style>
